import request from "../Config/axios";

// -----------------------------------------------------------
export const Delete_Parking_Reserve_Api = async (id) => {
    const { data } = await request.delete(
        `/Parking_Reserve/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Parking_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Parking_Reserve/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Parking_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Parking_Reserve/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_Parking_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Parking_Reserve/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetByReserveId_Parking_Reserve_Api = async (id) => {
    const { data } = await request.get(
        `/Parking_Reserve/GetByReserveId/?reserveId=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Search_Parking_Reserve_Api = async (params) => {
    const { data } = await request.post(
        `/Parking_Reserve/Search`,
        params
    );
    return data;
};
// -----------------------------------------------------------
